import { useEffect, useState } from "react";
import api from "../../api/axios";

const AuthenticatedImage = ({ articleId, blobName, alt = "", className }) => {
    const [objectUrl, setObjectUrl] = useState(null);

    useEffect(() => {
        let currentUrl = null;
        let cancelled = false;

        const load = async () => {
            try {
                const response = await api.get(
                    `/article/${articleId}/images/${blobName}`,
                    { responseType: "blob" }
                );

                if (cancelled) return;

                currentUrl = URL.createObjectURL(response.data);
                setObjectUrl(currentUrl);
            } catch (err) {
                console.error("Failed to load image", err);
            }
        };

        if (articleId && blobName) {
            load();
        }

        return () => {
            cancelled = true;
            if (currentUrl) URL.revokeObjectURL(currentUrl);
        };
    }, [articleId, blobName]);

    if (!objectUrl) {
        return <div className={`${className ?? ""} authimg-loading`} />;
    }

    return <img className={className} src={objectUrl} alt={alt} />;
};

export default AuthenticatedImage;